// components/auth/AuthGate.jsx
import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm.jsx';

export function AuthGate({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = async () => {
        try {
            const response = await fetch('/auth/status');
            const data = await response.json();
            
            if (data.authenticated) {
                setUser(data.user);
            }
        } catch (error) {
            console.error('Auth status check failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = (userData) => {
        setUser(userData);
    };

    const handleLogout = async () => {
        try {
            await fetch('/auth/logout', { method: 'POST' });
            setUser(null);
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-2 text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <LoginForm onLogin={handleLogin} />;
    }

    // User is authenticated, render the dashboard with logout option.
    return (
        <div className="h-screen flex flex-col overflow-hidden">
            {/* Yellow Header - Fixed at top */}
            <div className="flex-shrink-0 bg-white shadow-sm border-b border-gray-200">
                <div className="w-full px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-4">
                        <div className="flex items-center">
                            <img 
                                src="dashboard-logo.png" 
                                alt="Analytics Dashboard" 
                                className="h-12 w-auto"
                                onError={(e) => {
                                    // Fallback to text if image fails to load
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'inline';
                                }}
                            />
                            <span className="text-sm font-medium text-gray-900" style={{display: 'none'}}>
                                Analytics Dashboard
                            </span>
                        </div>
                        <div className="flex items-center space-x-4">
                            <span className="text-sm text-gray-500">
                                {user.email}
                            </span>
                            <button
                                onClick={handleLogout}
                                className="text-sm text-gray-700 hover:text-gray-900 px-3 py-1 rounded border border-gray-300 hover:bg-gray-50"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex-1 min-h-0 overflow-hidden">
                {/* Main content area - fills remaining height */}
                <div className="h-full min-h-0">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AuthGate;
